"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpinner = exports.SpinnerContextProvider = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const useStyles = (0, styles_1.makeStyles)({
    container: {
        display: 'flex',
        position: 'fixed',
        inset: 0,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    backdrop: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: '#ddd',
        opacity: 0.5,
    },
});
const SpinnerContext = react_1.default.createContext({
    toggleSpinner: (loading) => null,
});
const SpinnerContextProvider = props => {
    const classes = useStyles();
    const [show, setShow] = (0, react_1.useState)(!!props.show);
    (0, react_1.useEffect)(() => {
        setShow(!!props.show);
    }, [props.show]);
    const toggleSpinner = (value) => {
        setShow(value);
    };
    return (react_1.default.createElement(SpinnerContext.Provider, { value: {
            toggleSpinner,
        } },
        props.children,
        show && (react_1.default.createElement("div", { className: classes.container },
            react_1.default.createElement("div", { className: classes.backdrop }),
            react_1.default.createElement(CircularProgress_1.default, { color: "primary" })))));
};
exports.SpinnerContextProvider = SpinnerContextProvider;
const useSpinner = () => (0, react_1.useContext)(SpinnerContext);
exports.useSpinner = useSpinner;
//# sourceMappingURL=SpinnerContext.js.map